
import { ReminderConfig } from "@/models/dossier-configs/reminder-config";
import { ReminderService } from "@/services/reminder-service";
import { DocumentLayoutInfo } from "@/utils/documents/layout-info";
import { ISelectItem } from "winfakt-vue-components";
import { AuthService } from "@/services/auth-service";
import AppMissingModule from "@/components/common/MissingModule.vue";
import AppWeekdaySelect from "@/components/common/WeekDaySelect.vue";
import { MODULE } from "@/config/modules";
import Vue from "vue";
import AppAllUsersMailSettingsAutocomplete from "@/components/mail/AllUsersMailSettingsAutocomplete.vue";

export default Vue.extend({
	data() {
		return {
			layouts: [] as DocumentLayoutInfo[],
			hasLayoutSelectError: false
		};
	},
	props: {
		value: {
			type: Object as () => ReminderConfig,
			required: true
		}
	},
	computed: {
		layoutItems():ISelectItem<number>[] {
			return this.layouts.map((l) => {
				return {
					text: l.Name,
					value: l.ID
				};
			});
		},
		weekDayItems():ISelectItem<number>[] {
			return this.layouts.map((l) => {
				return {
					text: l.Name,
					value: l.ID
				};
			});
		},
		automationModule():MODULE{
			return MODULE.AUTOMATISCHE_HERINNERINGSBRIEVEN;
		},
		hasModuleAutomation():boolean{
			return AuthService.wfCompany.hasModule(this.automationModule);
		},
		isLayoutValid():boolean {
			if (!this.hasModuleAutomation) {
				return true;
			}
			if (!this.value.AutomaticRemindersEnabled){
				return true;
			}
			if (this.value.AutomaticLayoutID == 0) {
				return false;
			}
			if (this.layouts.findIndex(l=>l.ID == this.value.AutomaticLayoutID) == -1) {
				return false;
			}
			return true;
		},
		reminder2PeriodValid():boolean {
			if (!this.hasModuleAutomation){
				return true;
			}
			if (!this.value.AutomaticRemindersEnabled){
				return true;
			}
			if (this.value.AutomaticSend2AfterDays <= this.value.AutomaticSend1AfterDays) {
				return false;
			}
			return true;
		},
		reminder3PeriodValid():boolean {
			if (!this.hasModuleAutomation){
				return true;
			}
			if (!this.value.AutomaticRemindersEnabled){
				return true;
			}
			if (this.value.AutomaticSend3AfterDays <= this.value.AutomaticSend2AfterDays) {
				return false;
			}
			return true;
		},
		reminder4PeriodValid():boolean {
			if (!this.hasModuleAutomation){
				return true;
			}
			if (!this.value.AutomaticRemindersEnabled){
				return true;
			}
			if (this.value.AutomaticSend4AfterDays <= this.value.AutomaticSend3AfterDays) {
				return false;
			}
			return true;
		}
	},
	methods: {
		async sendAuto(){
			await ReminderService.listAutoReminders();
		},
		layoutValidator(value:number):(boolean | string){
			return this.isLayoutValid;
		},
		reminder2PeriodValidor(value:number):boolean {
			return this.reminder2PeriodValid;
		},
		reminder3PeriodValidor(value:number):boolean {
			return this.reminder3PeriodValid;
		},
		reminder4PeriodValidor(value:number):boolean {
			return this.reminder4PeriodValid;
		},
	},
	async created() {
		this.layouts = await ReminderService.getReminderLayouts();
	},
	components: {
		AppMissingModule,
		AppWeekdaySelect,
		AppAllUsersMailSettingsAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
